import Cookies from 'js-cookie'
import { getOpenEmbedModeFlag } from '@/utils/openEmbedSession'

const TokenKey = 'loginToken'
const EmbedTokenKey = 'openEmbedLoginToken'

export function getToken() {
  const cookieToken = Cookies.get(TokenKey)
  if (cookieToken) return cookieToken
  if (getOpenEmbedModeFlag()) {
    try {
      return sessionStorage.getItem(EmbedTokenKey) || ''
    } catch (e) {
      return ''
    }
  }
  return cookieToken
}

export function setToken(token) {
  Cookies.set(TokenKey, token)
  if (getOpenEmbedModeFlag()) {
    try {
      sessionStorage.setItem(EmbedTokenKey, token)
    } catch (e) {
      /* ignore */
    }
  }
  return token
}

export function removeToken() {
  Cookies.remove(TokenKey)
  try {
    sessionStorage.removeItem(EmbedTokenKey)
  } catch (e) {
    /* ignore */
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js